import React from "react";
import { connect } from "react-redux";

import Sectors from "./Sectors";

const SectorsContainer = props => {
  return <Sectors {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    currentClientId: state.currentClient.id
  };
};

export default connect(mapStateToProps)(SectorsContainer);



// WEBPACK FOOTER //
// src/containers/metier/referential/Sectors.container.js